import { render } from "./DashboardIcon.vue?vue&type=template&id=8e484ff0&ts=true"
import script from "./DashboardIcon.vue?vue&type=script&lang=ts"
export * from "./DashboardIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__